import { merge } from 'node-diff3';
export const DEFAULT_DOMAIN = 'ntub.edu.tw';
export const DEFAULT_EDITOR = '11246076@ntub.edu.tw';
export function roleForIdentity(identity, domain = DEFAULT_DOMAIN, editor = DEFAULT_EDITOR) {
  if (!identity || identity.email_verified !== true || identity.hd !== domain) return null;
  const email = String(identity.email || '').toLowerCase();
  if (email.split('@')[1] !== domain) return null;
  return email === editor.toLowerCase() ? 'editor' : 'reader';
}
export function mergeMarkdown(base, local, remote) {
  const normalize = value => String(value || '').replace(/\r\n?/g, '\n');
  base = normalize(base); local = normalize(local); remote = normalize(remote);
  if (local === remote) return { conflict: false, content: local };
  if (local === base) return { conflict: false, content: remote };
  if (remote === base) return { conflict: false, content: local };
  const result = merge(local.split('\n'), base.split('\n'), remote.split('\n'), { label: { a: '平台版本', o: '上次同步', b: 'Drive 版本' } });
  return { conflict: result.conflict, content: result.result.join('\n') };
}
export function containsConflict(content) {
  return /^(?:<{7}|={7}|>{7})(?:\s|$)/m.test(content);
}
